import { Component, OnInit, Input } from '@angular/core';
import { IConfig } from 'src/app/modules/core/interfaces/config';
import { TargetAppService } from 'src/app/modules/core/services/parameter';
import { IApplication } from 'src/app/modules/core/interfaces';

@Component({
  selector: 'app-main-layout1',
  templateUrl: './main-layout1.component.html',
  styleUrls: ['./main-layout1.component.scss']
})
export class MainLayout1Component implements OnInit {

  @Input()
  public config: IConfig;

  constructor(
    private app: TargetAppService
  ) {
  }

  ngOnInit() {
  }

}
